import { format, formatDistanceToNowStrict, isToday, isYesterday, parseISO } from 'date-fns';
import { ptBR } from 'date-fns/locale';

export function toDate(value) {
  return typeof value === 'string' ? parseISO(value) : value;
}

export function formatDate(value, pattern = 'dd/MM/yyyy') {
  return format(toDate(value), pattern, { locale: ptBR });
}

export function formatDateTime(value) {
  return format(toDate(value), 'dd/MM/yyyy HH:mm', { locale: ptBR });
}

export function formatTime(value) {
  return format(toDate(value), 'HH:mm', { locale: ptBR });
}

export function timeAgo(value) {
  return formatDistanceToNowStrict(toDate(value), { addSuffix: true, locale: ptBR });
}

export function formatConversationTimestamp(value) {
  const date = toDate(value);
  if (isToday(date)) return formatTime(date);
  if (isYesterday(date)) return 'Ontem';
  return formatDate(date);
}
